import { Component } from '@angular/core';
import { environment } from '@ca/environment/environment';
import { UserService } from '../../../services/user.service';

type NavSection = 'resource-menu' | 'content-menu' | '';

@Component({
    selector: 'ca-sidebar-mobile-logged-out-nav',
    templateUrl: './sidebar-mobile-logged-out-nav.component.html',
    styleUrls: ['./sidebar-mobile-logged-out-nav.component.scss'],
})
export class SidebarMobileLoggedOutNavComponent {
    openedNavSection: NavSection;

    constructor(private userService: UserService) {}

    get isLoggedIn(): boolean {
        return this.userService.isLoggedIn;
    }

    get landingPageUrl(): string {
        return environment.landingPageUrl;
    }

    toggleNavSection(section: NavSection): void {
        if (this.openedNavSection === section) {
            this.openedNavSection = '';
        } else {
            this.openedNavSection = section;
        }
    }

    isSectionOpen(section: string): boolean {
        return section === this.openedNavSection;
    }
}
